import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import pptxgen from "pptxgenjs";
import { ExportService } from 'src/app/services/export.service';
import { MessageService, ConfirmationService, ConfirmEventType } from 'primeng/api';

@Component({
  selector: 'app-assessment-results',
  templateUrl: './assessment-results.component.html',
  styleUrl: './assessment-results.component.scss'
})
export class AssessmentResultsComponent {
  getColumnValueCount(row: any, column: string): number {
    const field = row.meta.fields.find((f: { field: { label: string; }; }) => f.field.label === column);
    return field ? field.value.length : 0;
  }

  from: string = 'assessment';
  assessmentId: string = '';
  header = this.translate(this.from + ' Results');
  exportingPPT: boolean = false;
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: ``,
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate(this.from), link: `/${this.from}/` },
    { name: this.translate(this.from + ' Results'), link: `/${this.from}/results/` },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  messages: any[] = [];
  invitees: any[] = [];
  graphData: any[] = [];
  userResults: any[] = [];
  activeTabIndex: number = 0;
  activeResultTabIndex: number = 0;
  tabIndex: number = 0;
  currentQBankId: string = "";
  chartData: any;
  barChartOptions = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: 'SSTArabic'
          }
        },
        display: false
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
          color: 'white',
          autoSkip: false, // Keeps all labels
          maxTicksLimit: 10, // Limits number of visible labels
          maxRotation: 90,
        }
      },
      y: {
        ticks: {
          font: {
            size: 10,
            family: 'SSTArabic'
          },
          color: 'white',
          stepSize: 10, // Adjusted for cleaner percentage steps
          callback: function (value: string) {
            return value + '%'; // Adds '%' symbol to each tick
          }
        },
        max: 100 // Ensures Y-axis is capped at 100
      }
    }
  };
  page: number = 1;
  rows: number = 10;
  first = 1;

  totalInvitees: number = 0;
  totalUserResults: number = 0;
  types: any = [
    { id: 1, label: this.translate('Internal Users') },
    { id: 2, label: this.translate('External Users') }
  ];
  dropType: any
  filteredInvitees: any;
  filteredResults: any;
  noGraphs: string[] = ['MULTI_POINT_SCALE', 'MULTI_SELECT_SCALE', 'RANK_ORDER', 'DATE_TIME', 'PRESENTATION_TEXT', 'SECTION_HEADING', 'SECTION_SUB_HEADING'];
  assessment: any;
  showInviteDropdown: boolean = false;
  showResultDropdown: boolean = false;

  skelition: boolean = false;
  courseId: string = '';
  ratingFor: string = '';
  ratingForID: string = '';
  isRating: boolean = false;
  downloadExcel: boolean = false
  regenAttempt: boolean = false
  sendCert: boolean = false
  external: any = null
  searchText: string = ''
  isFilterApplied: boolean = false
  emailModal: boolean = false
  emailText: string = "";
  emailLink: string = "";
  selectedUsers: string[] = [];
  source: string = "";
  activeTRTabIndex: number = 0;
  tFrom: string = '';
  TypeId: string = '';
  Main: number = 0;
  totalGradesData: any[] = [];

  chartColors = ["003f5c", "0077b6", "084c61", "177e89", "3066be", "00a9b5", "58508d", "bc5090", "db3a34", "ff6361", "ffa600"];

  cacheCount: number = 0;
  downloadExcelCache: boolean = false
  downloadCWExcel: boolean = false
  downloadPdf: boolean = false
  downloadPdfExcel: boolean = false
  assessmentIds: any;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private exportService: ExportService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {

      if (params['ids']) {
        this.assessmentIds = params['ids'];
      }

      if (params['page'] && params['rows']) {
        this.page = Number(params['page']);
        this.rows = Number(params['rows']);
      }

      if (params['external']) {
        this.external = params['external'];
      }

      if (params['searchText']) {
        this.searchText = params['searchText'];
      }

      if (params['QBankId']) {
        this.currentQBankId = params['QBankId'];
      }

      if (params['tabIndex']) {
        const savedTabIndex = +params['tabIndex'];
        if (!isNaN(savedTabIndex)) {
          this.tabIndex = savedTabIndex;
        }
      }

      if (params['courseId']) {
        this.courseId = params['courseId'];
      }

      if (params['ratingFor']) {
        this.ratingFor = params['ratingFor'];
        this.isRating = true;
      }

      if (params['ratingForID']) {
        this.ratingForID = params['ratingForID'];
        this.isRating = true;
      }

      if (params['activeTabIndex']) {
        const activeTabIndex = +params['activeTabIndex'];
        if (!isNaN(activeTabIndex)) {
          this.activeTabIndex = activeTabIndex;
        }
      }

      if (params['tabResultIndex']) {
        const tabResultIndex = +params['tabResultIndex'];
        if (!isNaN(tabResultIndex)) {
          this.activeResultTabIndex = tabResultIndex;
        }
      }

      if (params['activeTRTabIndex']) {
        const activeTRTabIndex = +params['activeTRTabIndex'];
        if (!isNaN(activeTRTabIndex)) {
          this.activeTRTabIndex = activeTRTabIndex;
        }
      }

      if (params['from']) {
        this.tFrom = params['from'];
      }

      if (params['_id']) {
        this.courseId = params['_id'];
      }

      if (params['source']) {
        this.source = params['source'];
      }

      if (params['TypeId']) {
        this.TypeId = params['TypeId'];
      }

      if (params['Main']) {
        this.Main = params['Main'];
      }

      if (this.assessmentId) {
        this.fetchMainData().then(() => {
          if (this.source == 'training') {
            this.breadcrumbs[2].name = this.assessment.name;
          }
          else {
            this.breadcrumbs[1].name = this.assessment.name;
          }
          this.header = this.assessment.name
          this.fetchData().then(() => {
            this.fetchGraphData();
            this.fetchCacheExcelCount();
          });
        });
      }
    })

    this.route.params.subscribe(params => {
      this.assessmentId = params['assessmentId'];
      this.from = params['from'];
      this.header = this.translate(this.from + ' Results');

      let queryParams: any = {}
      if (this.source == 'training') {
        queryParams['_id'] = this.courseId;
        queryParams['from'] = this.tFrom;
        queryParams['activeTRTabIndex'] = this.activeTRTabIndex;

        this.links[0].link = '/training/training-results/' + this.courseId;
        this.links[0].queryParams = queryParams;
        this.breadcrumbs[0] = {
          name: this.translate('Training'),
          link: `/training/training-page/` + this.courseId,
          queryParams: { _id: this.courseId, from: this.tFrom }
        };
        this.breadcrumbs[1] = {
          name: this.translate('Training Results'),
          link: `/training/training-results/` + this.courseId,
          queryParams: { _id: this.courseId, from: this.tFrom, activeTRTabIndex: this.activeTRTabIndex }
        };
        this.breadcrumbs[2] = {
          name: this.translate(this.from + ' Results'),
          link: `/${this.from}/results/` + this.assessmentId,
          queryParams: { _id: this.courseId, from: this.tFrom, activeTRTabIndex: this.activeTRTabIndex, source: this.source }
        };
      }
      else {
        if (this.from == 'assessment') {
          queryParams['QBankId'] = this.currentQBankId;
          queryParams['tabIndex'] = this.tabIndex;
        }
        else {
          queryParams['TypeId'] = this.TypeId;
        }

        if (this.Main) {
          this.links[0].link = `/${this.from}`
        }
        else {
          this.links[0].link = `/${this.from}/add-question/` + this.assessmentId;
        }
        this.links[0].queryParams = queryParams;
        this.breadcrumbs[0] = {
          name: this.translate(this.from),
          link: `/${this.from}`,
          queryParams: queryParams
        };
        this.breadcrumbs[1] = {
          name: this.translate(this.from + ' Results'),
          link: `/${this.from}/results/` + this.assessmentId,
          queryParams: queryParams
        };
      }

      if (this.assessmentId) {
        this.fetchMainData().then(() => {
          this.header = this.assessment.name
          if (this.source == 'training') {
            this.breadcrumbs[2].name = this.assessment.name;
          }
          else {
            this.breadcrumbs[1].name = this.assessment.name;
          }
          this.fetchData().then(() => {
            this.fetchGraphData();
            this.fetchCacheExcelCount();
          });
        });
      }
    });
  }

  exportToPPT() {
    try {
      this.skelition = true;
      let pres = new pptxgen();
      let allData = this.totalGradesData.splice(3, 1)[0];

      console.log('ALL DATA', allData);

      const fontFace = "DIN Next LT Arabic";

      pres.defineSlideMaster({
        title: "MASTER_SLIDE",
        background: { color: "FFFFFF" },
        objects: [
          { text: { text: this.assessment.name.toString(), options: { x: '4%', y: '30%', w: 5.5, h: 0.75, fontSize: 30, bold: true, fontFace } } },
          { image: { x: '70%', y: '85%', w: '25%', h: '10%', path: "assets/sbc_logo.png" } },
        ],
      });

      pres.addSlide({ masterName: "MASTER_SLIDE" });

      //Top Stats
      let stats = this.totalGradesData.splice(3, 1)[0];
      console.log('1');
      if (stats) {
        let slide = pres.addSlide();
        slide.addText(":بيانات عامة ", { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace });
        let tableData: any[] = [
          [{ text: this.translate('Title'), options: { bold: true } }, { text: this.translate('statistics'), options: { bold: true } }].reverse()
        ];
        for (let item of stats) {
          tableData.push([this.translate(item?.key), item?.value?.value ?? ''].reverse());
        }
        console.log('TABLE', tableData);
        slide.addTable(tableData, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace });
      }

      //Pi Charts
      let finalGradeData = [this.totalGradesData[0], this.totalGradesData[1]];
      console.log('FINAL GRADE DATA', finalGradeData);
      console.log('2');
      for (let data of finalGradeData) {
        let slide = pres.addSlide();
        let chartData: any[] = [];

        for (let dataset of data.datasets) {
          chartData.push({ labels: data.labels, values: dataset.data });
        }
        slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 1, w: 8, h: 4, chartColors: this.chartColors, showLabel: false, dataLabelFontFace: fontFace, legendFontFace: fontFace, fontFace, titleFontFace: fontFace, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
      }

      console.log('3. here');
      //More Pi charts with heading
      let totalGrades = this.totalGradesData[2];
      if (!!totalGrades) {
        for (let data of totalGrades) {
          let slide = pres.addSlide();
          let chartData: any[] = [];

          for (let dataset of data.datasets) {
            chartData.push({ labels: data.labels, values: dataset.data });
          }

          console.log('DATA', data);

          let title = typeof data._id === 'string' ? data._id : data._id.label;
          slide.addText([{ text: title, options: { x: '40%', y: '20%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace } }]);
          slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 1, w: 8, h: 4, chartColors: this.chartColors, titleFontFace: fontFace, legendFontFace: fontFace, fontFace, showLabel: false, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
        }
      }

      //Card data in table
      let keys = [
        'Overall average for the assessment in percentage',
        'Overall average for the assessment in marks',
        'Overall average for the assessment in grades'
      ];

      console.log('4');
      if (!!allData) {
        let percentage = allData['Overall average for the assessment in percentage']?.value;
        let marks = allData['Overall average for the assessment in marks']?.value;
        let grades = allData['Overall average for the assessment in grades']?.value;

        const tableData: any[] = [];
        tableData.push([{ text: this.translate(keys[0]), options: { bold: true } }, { text: this.translate(keys[1]), options: { bold: true } }, { text: this.translate(keys[2]), options: { bold: true } }]);
        tableData.push([percentage, marks, grades]);

        let slide = pres.addSlide();
        slide.addText(":المعدل العام", { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace });
        slide.addTable(tableData, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace });
      }

      console.log('5');
      //Bar and tables
      for (let data of this.graphData) {
        if (data.type == 'bar') {
          let slide = pres.addSlide();
          let chartData: any[] = [];
          for (let dataset of data.graphData.datasets) {
            chartData.push({ name: dataset.label, labels: data.graphData.labels.flat(Infinity), values: dataset.data });
          }
          slide.addChart(pres.ChartType.bar, chartData, {
            title: data.questionText,
            x: 1,
            y: 1,
            w: 8,
            h: 4,
            showTitle: true,
            titleFontFace: fontFace,
            titleFontSize: 12, // Add explicit font size
            legendFontFace: fontFace,
            legendFontSize: 10,
            fontFace, // General font face
            dataLabelFontSize: 0,
            chartColors: this.chartColors,
            showLabel: false,
            showLegend: true,
            showPercent: true,
            // Add these additional options:
            valAxisLabelFontFace: fontFace, // For value axis labels
            catAxisLabelFontFace: fontFace, // For category axis labels
            valAxisLineShow: true,
            catAxisLineShow: true
          });
        } else if (data.type == 'text') {
          let tableData: any[] = [];

          for (const [index, dataset] of data.data.datasets.entries()) {
            tableData.push([{ text: data.data.labels[index]?.toString(), options: { bold: true } }]);
          }
          if (tableData.length > 0) {
            pres.addSlide().addTable(this.cleanArray(tableData), { border: { pt: 1, color: '808080', type: 'solid' }, autoPage: true, fontFace });
          }
        }
      }

      console.log('6');
      //Table Data
      if (!!this.filteredResults && this.filteredResults.length > 0) {
        let participents: any[] = [[
          { text: "الجنس", options: { bold: true } },
          { text: "رقم الهاتف المحمول", options: { bold: true } },
          { text: "البريد الإلكتروني", options: { bold: true } },
          { text: "الاسم", options: { bold: true } }]];
        for (let user of this.filteredResults) {
          participents.push([this.getUsername(user).toString() ?? "", user.email ?? "", user.phone ?? "", user.gender ?? ""].reverse());
        }
        console.log('7');
        let slide = pres.addSlide();
        slide.addText(":معلومات المشاركين", { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace });
        slide.addTable(participents, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace });
      }
      console.log('8');
      pres.writeFile({ fileName: this.assessment.name.toString() + "_KGATE_ASSESSMENT.pptx" }).then(() => {
        this.skelition = false;
      });
    } catch (e) {
      console.log('PRINT ERROR', e);
      this.skelition = false;
    }
  }


  getUsername(user: any) {
    console.log('DATA 2 USER', user)
    return !!user._id ?
      user.name.first + " " + user.name.middle + " " + user.name.last : user.name
  }

  cleanArray(arr: any[]): any[] {
    let first = arr
      .filter(item => item !== null && item !== undefined && item !== "")
      .map(item => Array.isArray(item) ? this.cleanArray(item) : item);
    return first.filter(e => {
      if (Array.isArray(e)) {
        return e.length > 0;
      }
      return e != null && e != undefined && e != "";
    })
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async fetchMainData() {
    try {
      let res = await this.dataService.getData(`${this.from}/id/${this.assessmentId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.assessment = res.data;
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchData() {
    this.skelition = true;
    try {

      let url = `${this.from}-result/${this.assessmentId}/${this.page}/${this.rows}`;
      let queryParams = [];

      if (this.isRating) {
        queryParams.push(`courseId=${this.courseId}`, `ratingFor=${this.ratingFor}`, `ratingForID=${this.ratingForID}`);
      }

      if (this.external) {
        queryParams.push(`external=${this.external}`);
      }

      if (this.searchText) {
        queryParams.push(`searchText=${this.searchText}`);
      }

      if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
      }

      console.log("URL", url)

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.invitees = res.data.inviteesResult;
      this.filteredInvitees = this.invitees;
      this.totalInvitees = res.data.inviteesCount;
      this.showInviteDropdown = this.totalInvitees > 0;
      this.userResults = res.data.userResults;
      this.filteredResults = this.userResults;
      this.totalUserResults = res.data.userResultsCount;
      this.showResultDropdown = this.totalUserResults > 0;
      this.skelition = false;
    } catch (e) {
      console.log("error", e)
    }
  }

  onTabChange(event: any) {
    this.activeResultTabIndex = event.index;
    this.isFilterApplied = false;
    this.searchText = '';
    this.dropType = null;
    this.external = null;
    const queryParams = { ...this.route.snapshot.queryParams };
    queryParams['tabResultIndex'] = this.activeResultTabIndex;
    delete queryParams['page'];
    delete queryParams['rows'];
    delete queryParams['external'];
    delete queryParams['searchText'];
    console.log('TAB CHANGED')
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams
    });
  }

  navigateToSearch(event: any) {
    if (event.target.value != '') {
      this.isFilterApplied = true;
      let params = { searchText: event.target.value };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: 'merge',
      });
    }
    else {
      const queryParams = { ...this.route.snapshot.queryParams };
      delete queryParams['searchText'];
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
      });
    }

  }

  async fetchPdfData() {
    try {
      let url = `${this.from}-result/pdf?ids=${encodeURIComponent(this.assessmentId)}`;
      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      return res.data;
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchExcelData() {
    try {

      let url = `${this.from}-result/excel?ids=${encodeURIComponent(this.assessmentId)}`;
      let queryParams = [];

      if (this.isRating) {
        queryParams.push(`courseId=${this.courseId}`, `ratingFor=${this.ratingFor}`, `ratingForID=${this.ratingForID}`);
      }

      if (this.external) {
        queryParams.push(`external=${this.external}`);
      }

      if (this.searchText) {
        queryParams.push(`searchText=${this.searchText}`);
      }

      if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
      }

      console.log("URL", url);

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      console.log("RES", res.data);
      return res.data
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchBulkExcelData() {
    try {
      let url = `${this.from}-result/bulkExcel?ids=${encodeURIComponent(this.assessmentId)}`;
      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      console.log("RES", res.data);
      return res.data;
    } catch (e) {
      console.log("error", e);
    }
  }


  async fetchCacheExcelData() {
    try {

      let url = `cache-controller/getExcelData`;
      let res = await this.dataService.postData(url, { _id: this.assessmentId });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      return res.data
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchCacheExcelCount() {
    try {
      let url = `cache-controller/getCount`;
      let res = await this.dataService.postData(url, { _id: this.assessmentId });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.cacheCount = res.data.count || 0;

      console.log("this.cacheCount", this.cacheCount)
    } catch (e) {
      console.log("error", e)
    }
  }

  onChangeDropdown() {
    let params: any = {};
    if (this.dropType) {
      this.isFilterApplied = true;
      if (this.dropType.id == 1) {
        params = { external: false };
      }
      else {
        params = { external: true };
      }
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: 'merge',
      });
    }
  }

  resetFilters() {
    this.dropType = null;
    this.external = null;
    this.searchText = '';
    this.isFilterApplied = false;
    const queryParams = { ...this.route.snapshot.queryParams };
    delete queryParams['external'];
    delete queryParams['searchText'];
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
    });
  }

  async fetchGraphData() {
    try {

      let url = `${this.from}-result/graph/${this.assessmentId}`;
      if (this.isRating) {
        url = url + "?courseId=" + this.courseId + "&ratingFor=" + this.ratingFor + "&ratingForID=" + this.ratingForID;
      }

      console.log("URL", url)

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.graphData = res.data;
      this.graphData.forEach(data => {
        if (data.type == 'bar') {
          data.graphData = this.getBarGraph(data.data, data.questionType);
        } else if (data.type == 'smile') {
          data.graphData = this.getSmileData(data.data);
          console.log("data.graphData", data.graphData);
        } else if (data.type == 'rate') {
          data.graphData = this.getStartData(data.data);
        } else if (data.questionType == "MULTI_SELECT_SCALE") {
          console.log(data);
          try {
            data.type = 'table'
          } catch (error) {
            console.log(error)
          }
        } else if (data.questionType == "CALENDAR") {
          try {
            data.type = 'calander'
          } catch (error) {
            console.log(error)
          }
        }
      });

      console.log("this.graphData", this.graphData)

    } catch (e) {
      console.log("Error", e)
    }
  }

  multiselectGraph(data: any): ChartDataset[] | null {
    if (!Array.isArray(data)) {
      data = [data]
    }

    const chartData: { labels: string[], values: number[] }[] = data.map((question: Question) => {
      if (!question.meta || !Array.isArray(question.meta)) {
        console.error('Error: Invalid data structure.');
        return null;
      }

      return question.meta.map((item: MetaItem) => {
        const columns: string[] = item.columns.map((column: string) => column);
        const values: number[] = item.fields.map((field: any) => field.value.length);
        return {
          labels: columns,
          values: values
        };
      });
    }).flat().filter(Boolean) as { labels: string[], values: number[] }[];

    // Creating chart datasets
    const datasets = chartData.map(item => {
      return {
        labels: item.labels,
        data: item.values,
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1
      };
    });
    return datasets;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const formattedDate = `${hours}:${minutes} ${day}-${month}-${year} `;
    return formattedDate;
  }

  getBarGraph(graphdata: any, name: string): any {
    const colorPalette = ['#facb7d', '#f7517f', '#47276d', '#290d4e', '#703d94', '#16ceb9', '#6648ff', '#3f4357'];
    const multiColorPalette: any = {
      "Correct": '#facb7d',
      "Incorrect": '#f7517f'
    };

    if (Array.isArray(graphdata.datasets)) {
      const processedDatasets = graphdata.datasets.map((dataset: any, datasetIndex: number) => {
        const sortedData = dataset.data
          .map((value: number, index: number) => ({ value, label: dataset.labels[index] }))
          .sort((a: { value: number; }, b: { value: number; }) => b.value - a.value);

        const sortedValues = sortedData.map((item: { value: any; }) => item.value);
        const sortedLabels = sortedData.map((item: { label: any; }) => item.label);

        let dataPercentage = sortedValues.map((value: number) => ((value / this.totalUserResults) * 100).toFixed(2));
        let concatenatedLabels = sortedValues.map((data: string, index: number) => `(${data}) ${sortedLabels[index]}`);
        let backgroundColors = sortedValues.map(() => multiColorPalette[dataset.label] || '#cccccc');

        return {
          backgroundColor: backgroundColors,
          label: dataset.label,
          data: dataPercentage
        };
      });

      return {
        labels: this.labelmaker(graphdata.labels),
        datasets: processedDatasets
      };
    } else if (typeof graphdata.datasets === 'object') {
      const sortedData = graphdata.datasets.data
        .map((value: number, index: number) => ({ value, label: graphdata.label[index] }))
        .sort((a: { value: number; }, b: { value: number; }) => b.value - a.value);

      const sortedValues = sortedData.map((item: { value: any; }) => item.value);
      const sortedLabels = sortedData.map((item: { label: any; }) => item.label);

      let dataPercentage = sortedValues.map((value: number) => ((value / this.totalUserResults) * 100).toFixed(2));
      let concatenatedLabels = sortedValues.map((data: string, index: number) => `(${data}) ${sortedLabels[index]}`);
      let backgroundColors = sortedValues.map((_: any, index: number) => colorPalette[index % colorPalette.length]);

      return {
        labels: this.labelmaker(concatenatedLabels),
        datasets: [
          {
            backgroundColor: backgroundColors,
            label: graphdata.datasets.label,
            data: dataPercentage
          }
        ]
      };
    }
  }

  labelmaker(inputArray: string[]): string[][] {
    const result: string[][] = [];
    inputArray.forEach(item => {
      if (item.length <= 30) {
        result.push([item]);
      } else {
        result.push(["..." + item.substring(0, 30)]);
      }
    });
    return result;
  }

  getSmileData(data: any) {
    const labels = data.label;
    const images = data.label_images;
    const datasets = data.datasets.data;
    if (labels.length === images.length && images.length === datasets.length) {
      return labels.map((label: string, index: number) => {
        return { label, image: images[index], count: ((datasets[index] / this.totalUserResults) * 100).toFixed(2) };
      });
    }
  }

  getStartData(data: any) {
    const labels = data.label;
    const datasets = data.datasets.data;
    if (labels.length === datasets.length) {
      return labels.map((label: string, index: number) => {
        return { label, value: datasets[index] };
      });
    }
  }


  onPageChange(event: any, index: number) {
    if (this.assessment.accessType == 'BY_ACCOUNT') {
      if (this.activeResultTabIndex != index) {
        return;
      }
    }
    this.isFilterApplied = true;
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1
    this.currentQBankId = "";

    const params = { page: this.page, rows: this.rows };


    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  async regenerateAttempts() {
    try {
      this.regenAttempt = true;
      let url = `${this.from}-attempt/${this.assessmentId}`;
      let res = await this.dataService.postData(url, '');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.generateResults();
    } catch (e) {
      console.log("error", e)
    }
  }

  async generateResults() {
    try {
      let res = await this.dataService.postData(
        `${this.from}-result/regenerate/${this.assessmentId}`,
        ''
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        this.regenAttempt = false;
        return;
      }

      this.messageService.add({
        severity: 'success',
        summary: this.translate('success'),
        detail: this.translate('Results Genereted Successfully')
      })
      this.regenAttempt = false;
    } catch (e) { }
  }

  public async exportExcelCache() {
    this.downloadExcelCache = true
    let cleanData: any = await this.fetchCacheExcelData();
    let updatedDataArray;
    if (this.from == 'assessment') {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields, score, total, percentage, percentageCriteria } = item;

        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-',
          'الدرجة': this.formatScore(score),
          'الدرجة الكلية': total,
          'النسبة': this.formatScore(percentage),
          'التقدير': percentageCriteria
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }
    else {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields } = item;
        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-'
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadExcelCache = false
  }

  public async exportExcel() {
    this.downloadExcel = true
    let cleanData: any = await this.fetchExcelData()
    let updatedDataArray;
    if (this.from == 'assessment') {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields, score, total, percentage, percentageCriteria } = item;
        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-',
          'الدرجة': this.formatScore(score),
          'الدرجة الكلية': total,
          'النسبة': this.formatScore(percentage) + '%',
          'التقدير': percentageCriteria
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }
    else {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields } = item;
        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-'
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadExcel = false
  }

  public async exportPdf() {
    this.downloadPdf = true;
    let cleanData: any = await this.fetchPdfData();

    let pageOrientation: any = 'portrait';
    let updatedDataArray = cleanData.map((item: any) => {

      let updatedItem: any;

      if (this.from == 'assessment') {
        pageOrientation = 'landscape'
        const { name, email, phone, gender, score, totalMarks, criteria, timeTaken, attemptEndDate, percentage, questions } = item;

        
        updatedItem = {
          'التقدير': this.reverseWordsForRTL(criteria || '-'),
          'المستغرق  الوقت': this.reverseWordsForRTL(timeTaken || '-'),
          'النسبة': this.formatScore(percentage) + " %" || '-',
          [`${totalMarks} من  الدرجة`]: this.formatScore(score || '-'),
          'الجنس': this.reverseWordsForRTL(gender || '-'),
          'الهاتف  المحمول  رقم': this.reverseWordsForRTL(phone || '-'),
          'الإلكتروني  البريد': this.reverseWordsForRTL(email || '-'),
          'الاسم': this.reverseWordsForRTL(this.getName(name) || '-'),
        };
      }
      else {
        const { name, email, phone, gender, timeTaken } = item;
        updatedItem = {
          'الجنس': this.reverseWordsForRTL(gender || '-'),
          'الهاتف  المحمول  رقم': this.reverseWordsForRTL(phone || '-'),
          'الإلكتروني  البريد': this.reverseWordsForRTL(email || '-'),
          'الاسم': this.reverseWordsForRTL(this.getName(name) || '-'),
        };
      }
      return updatedItem;
    });

    console.log("updatedDataArray", updatedDataArray)

    this.exportService.exportToPdf(updatedDataArray, this.assessment.name, pageOrientation);
    this.downloadPdf = false
  }

  public async exportPdfFormatExcel() {
    this.downloadPdfExcel = true;
    let cleanData: any = await this.fetchPdfData();

    let pageOrientation: any = 'portrait';
    let updatedDataArray = cleanData.map((item: any) => {

      let updatedItem: any;

      if (this.from == 'assessment') {
        pageOrientation = 'landscape'
        const { name, email, phone, gender, score, totalMarks, criteria, timeTaken, attemptEndDate, percentage, questions } = item;

        
        updatedItem = {
          'الاسم': this.getName(name) || '-',
          'البريد الإلكتروني': email || '-',
          'رقم الهاتف المحمول': phone || '-',
          'الجنس': gender || '-',
          [`الدرجة من ${totalMarks}`]: this.formatScore(score) || '-',
          'النسبة': this.formatScore(percentage) + " %" || '-',
          'الوقت المستغرق': timeTaken || '-',
          'التقدير': criteria || '-',
        };
      }
      else {
        const { name, email, phone, gender, timeTaken } = item;
        updatedItem = {
          'الاسم': this.getName(name) || '-',
          'البريد الإلكتروني': email || '-',
          'رقم الهاتف المحمول': phone || '-',
          'الجنس': gender || '-',
        };
      }
      return updatedItem;
    });

    console.log("updatedDataArray", updatedDataArray)

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadPdfExcel = false
  }

  isArabicText(text: string): boolean {
    const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
    return arabicPattern.test(text);
  }

  reverseWordsForRTL(text: string): string {
    if (this.isArabicText(text)) {
      return text.split(' ').reverse().join('  ');
    }
    return text;
  }

  public async exportCorrectWrongExcel() {
    this.downloadCWExcel = true
    let cleanData: any = await this.fetchBulkExcelData()
    let updatedDataArray;
    updatedDataArray = cleanData.map((item: any) => {
      const { question, correct, incorrect } = item;
      let updatedItem: any = {
        'السؤال': question,
        'الإجابات الصحيحة': correct,
        'الإجابات الخاطئة': incorrect
      };
      return updatedItem;
    });

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadCWExcel = false
  }

  handleSelectedUsersChange(selectedUsers: string[]): void {
    this.selectedUsers = selectedUsers;
  }


  async sendEmail() {
    if (this.selectedUsers.length == 0) {
      this.emailModal = false;
      this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Select Users to Send Email') })
      return false;
    }

    if (this.emailText == "") {
      this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Email Text') })
      return false;
    }

    if (this.emailLink == "") {
      this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Email Link') })
      return false;
    }
    const parts = this.emailLink.split('/attempt/');
    const id = parts[1] ? parts[1].split('?')[0] : null;

    try {
      this.skelition = true;
      let data = {
        _id: id,
        emailText: this.emailText,
        emailLink: this.emailLink,
        emails: this.selectedUsers
      }
      let res = await this.dataService.postData(`${this.from}-result/sendEmailUsers`, data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.emailModal = false;
      this.emailLink = "";
      this.emailText = "";
      this.selectedUsers = [];
      this.skelition = false;
    } catch (error) {
      this.skelition = false;
      console.log(error);
    }
    return true;
  }

  async sendCertificate() {
    if (this.selectedUsers.length == 0) {
      const confirmed = await this.confirm({
        message: this.translate('Are you sure you want to send Certificate to All Users'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: async () => {
          this.sendCertificateConfirm();
        },
        reject: async () => {
          return false;
        }
      });
      return confirmed;
    }
    else {
      await this.sendCertificateConfirm();
      return;
    }
  }

  async sendCertificateConfirm() {
    try {
      this.skelition = true;
      let data = {
        assessmentId: this.assessmentId,
        emails: this.selectedUsers
      }
      let res = await this.dataService.postData(`${this.from}-result/sendCertEmailUsers`, data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.selectedUsers = [];
      this.skelition = false;
    } catch (error) {
      this.skelition = false;
      console.log(error);
    }
  }

  async deleteUsers() {
    if (this.selectedUsers.length === 0) {
      this.emailModal = false;
      this.messageService.add({
        severity: 'error',
        summary: this.translate('error'),
        detail: this.translate('Please Select Users to Send Email')
      });
      return false;
    }

    const confirmed = await this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          this.skelition = true;
          const data = {
            _id: this.assessmentId,
            emails: this.selectedUsers
          };
          const res = await this.dataService.postData(`${this.from}-result/deleteUsers`, data);

          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg }
            ];
            return;
          }
          this.selectedUsers = [];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        } finally {
          this.skelition = false;
        }
      }
    });

    return confirmed;
  }

  formatScore(value: number) {
    if (value % 1 === 0 || value.toFixed(2).endsWith('.00')) {
      return Math.trunc(value);
    } else {
      return value.toFixed(2);
    }
  }

  confirm(params: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm({
        message: params.message,
        header: params.header,
        icon: params.icon,
        acceptLabel: 'نعم',
        rejectLabel: 'لا',
        accept: async () => {
          try {
            await params.action();
            resolve(true);
          } catch (error) {
            console.error("Confirmation action failed", error);
            reject(false);
          }
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
            case ConfirmEventType.CANCEL:
            default:
              resolve(false);
              break;
          }
        }
      });
    });
  }

  getName(name: any): string {
    if (typeof name === 'object' && name !== null) {
      return Object.values(name).join(' ');
    } else {
      return name;
    }
  }
}



interface MetaItem {
  columns: string[];
  fields: { value: any[] }[];
}

interface Question {
  meta: MetaItem[];
}

interface ChartDataset {
  labels: string[];
  data: number[];
  backgroundColor: string;
  borderColor: string;
  borderWidth: number;
}